module.exports = __webpack_public_path__ + "img/hunzhiCode2.a30bc424.jpeg";